
import React from 'react';
import { LoginLayout } from '../components/auth/LoginLayout';
import { LoginAlerts } from '../components/auth/LoginAlerts';
import { LoginForm } from '../components/auth/LoginForm';
import { useLoginState } from '../hooks/useLoginState';

const Login = () => {
  const {
    formData,
    showPassword,
    setShowPassword,
    isLoading,
    isLocked,
    loginAttempts,
    checkEmailMessage,
    emailConfirmedMessage,
    resetMessage,
    resetEmailSent,
    handleSubmit,
    handleInputChange,
    handlePasswordReset
  } = useLoginState();

  return (
    <LoginLayout isLocked={isLocked}>
      <LoginAlerts
        checkEmailMessage={checkEmailMessage}
        emailConfirmedMessage={emailConfirmedMessage}
        isLocked={isLocked}
        loginAttempts={loginAttempts}
      />
      
      <LoginForm
        formData={formData}
        showPassword={showPassword}
        isLoading={isLoading}
        isLocked={isLocked}
        resetMessage={resetMessage}
        resetEmailSent={resetEmailSent}
        onSubmit={handleSubmit}
        onInputChange={handleInputChange}
        onTogglePassword={() => setShowPassword(!showPassword)}
        onPasswordReset={handlePasswordReset}
      />
    </LoginLayout>
  );
};

export default Login;
